import React from "react";
import CountUp from "react-countup";
import OwlCarousel from "react-owl-carousel";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";

const testimonials = [
  {
    reviewername: "Harneet Kaur",
    position: "Google Reviews",
    review:
      '“Amazing work by the team at Sunlight Creationz Inc. I hired them for my engagement decor and it turned out better than I could have imagined! The team was super responsive and professional! Highly recommend them for any decor needs!"',
  },
  {
    reviewername: "Sapna Patel",
    position: "Google Reviews",
    review:
      "“Gurnish was a delight to work with, she was so helpful and had so many great ideas to make my vision come true!! I connected with her well over a year before the big day and she remained as tentative as the first meeting. As all brides will relate, things can get very hectic closer to the wedding. And I had a huge issue were the aisle ended up being double the size. But Gurnish was amazing and helped me figure out how I can make the aisle as grand as I wanted.I would highly recommend sunlight creationz for you special day!!”",
  },
  //   {
  //     image: require("./../../images/testimonials/pic3.jpg"),
  //     reviewername: "Mehkansh Sharma",
  //     position: "Google Reviews",
  //     review:
  //       "“Our experience with Sunlight Creationz for our wedding, reception and haldi/sangeet decor was nothing short of exceptional. From the moment we started planning, Gurnish and the team were incredible to work with. They took our ideas and transformed them into a breathtaking reality that far surpassed our expectations.The decor was absolutely stunning, with every detail thoughtfully crafted to enhance the beauty of our venue. The floral arrangements, lighting, and table settings were all perfectly coordinated, creating a magical atmosphere that our guests are still raving about.Gurnish’s creativity and dedication were evident throughout the entire process, and we felt completely confident in their ability to bring our vision to life. If you are looking for a decor team that truly cares about making your day special, Sunlight Creationz is the one to choose.”",
  //   },
];

var bgimg1 = require("./../../images/background/bg-image.png");
var bgimg2 = require("./../../images/background/bg-5.png");
var bgimg3 = require("./../../images/background/cross-line2.png");
var bgimg4 = require("./../../images/background/bg-image.png");

class Testimonials1 extends React.Component {
  render() {
    const options = {
      loop: true,
      autoplay: true,
      margin: 30,
      autoplayTimeout: 6000,
      nav: false,
      dots: true,
      navText: [
        '<i class="fa fa-angle-left"></i>',
        '<i class="fa fa-angle-right"></i>',
      ],
      responsive: {
        0: {
          items: 1,
        },
        600: {
          items: 1,
        },
        1000: {
          items: 1,
        },
      },
    };
    return (
      <>
        <div className="section-full container-fluid">
          <div className="section-content ">
            <div className="row">
              <div
                className="col-xl-12 col-lg-12 col-md-12 bg-white bg-repeat sx-center"
                style={{ backgroundImage: "url(" + bgimg4 + ")" }}
              >
                <div className="sx-center-part mobile-page-padding  p-t80 p-b50">
                  {/* TITLE START */}
                  <div className="section-head">
                    <div className="sx-separator-outer separator-center">
                      <div
                        className="sx-separator bg-moving bg-repeat-x"
                        style={{ backgroundColor: "#22333B" }}
                      >
                        <h3 className="sep-line-one">Love from Clients</h3>
                      </div>
                    </div>
                  </div>
                  {/* TITLE END */}
                  {/* TESTIMONIAL START */}
                  <OwlCarousel
                    className="owl-carousel testimonial-home number-slider"
                    {...options}
                  >
                    {testimonials.map((item, index) => (
                      <div className="item" key={index}>
                        <div className="testimonial-2  hover-animation-1">
                          <div className="testimonial-detail clearfix">
                            {/* <div className="testimonial-pic shadow scale-in-center"><img src={item.image} alt="" width={100} height={100} /></div> */}
                            <h4 className="testimonial-name">
                              {item.reviewername}
                            </h4>
                            <span className="testimonial-position">
                              {item.position}
                            </span>
                            <span className="fa fa-quote-right" />
                          </div>
                          <div className="testimonial-text bg-white  shadow-sm">
                            <p>{item.review}</p>
                          </div>
                        </div>
                      </div>
                    ))}
                  </OwlCarousel>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default Testimonials1;
